import * as types from './Types.js';

export function findCartaServicos(filtro) {
  return ({ fetch }) => ({
    type: types.CARTA_SERVICOS_LIST,
    payload: {
      promise: fetch('/api/carta-servicos?filtro=' + filtro)
    }
  });
}

export function print() {
  const windowParams = 'width=800, height=600';

  return ({ fetch }) => ({
    type: 'PRINT',
    payload: fetch('/api/carta-servicos/report')
      .then(response => response.blob())
      .then(file => URL.createObjectURL(file))
      .then(fileURL => window.open(fileURL, '_blank', windowParams))
  });
}
